<template>
  <label class="flex gap-2 items-center justify-center cursor-pointer">
    <slot>
      <span class="font-medium text-sm text-white">{{ label }}</span>
    </slot>
    <input
      type="checkbox"
      :id="id"
      v-model="model"
      :name="name"
      class="bg-midnight-slate"
    />
  </label>
</template>

<script setup lang="ts">
  interface Props {
    id: string;
    name: string;
    label: string;
  }
  defineProps<Props>();
  const model = defineModel<boolean>();
</script>
<style scoped>
  input[type='checkbox'] {
    appearance: none;
    margin: 0;
    font: inherit;
    width: 1.15em;
    height: 1.15em;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
  }

  input[type='checkbox']::before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em theme('colors.primary');
    background-color: CanvasText;
    transform-origin: bottom left;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
  input[type='checkbox']:checked::before {
    transform: scale(1);
  }

  input[type='checkbox']:disabled,
  .form-control--disabled {
    color: #959495;
    cursor: not-allowed;
  }
</style>
